import { Component, OnInit, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CommonHelper } from '../../../../../utilities/common.helper';
import { SharedService } from '../../../../../shared/sharedServices/shared.service';
import { ProfileComponent } from '../../profile.component';
import { HecResponse } from '../../../../../shared/shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../../../utilities/constants';
import { LoaderService } from '../../../../../shared/sharedServices/loader.service';

@Component({
  selector: 'kt-change-email',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.scss']
})
export class ChangeEmailComponent implements OnInit {
  @ViewChild('updateEmailForm',{static:false}) updateEmailForm: NgForm;
  public sendCode: boolean = false;
  public timer;
	public resendCodeSeconds: boolean = false;
	public isAlertVisible: boolean = false;
	public alertType: string;
	public alertIcon: string;
	public alertMsgValue: string;
	@ViewChild('seconds',{static:false}) elementView: ElementRef;

	constructor(private sharedServices:SharedService,private cdr:ChangeDetectorRef,
		private profileComp:ProfileComponent, private loaderService:LoaderService) { }

  ngOnInit() {
	  window.scroll(0,0)
  }

  public cancel(){
    this.sendCode = false
  }

	public submitUserRequest() {
		this.isAlertVisible = false;
		this.markFormsTouched(this.updateEmailForm)
		if (this.validate(this.updateEmailForm.form.controls.email)) {
			// this.profileComp.loader = true;
			this.loaderService.setValue(true)
			let payload = {
				data:{
				contactValue: this.updateEmailForm.value.email,
					verificationTypeId: 703103,
					checkEmail: true
				}
			}
			this.sharedServices.postSendEmailVerificationCode(payload).subscribe(
				(res: HecResponse) => {
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						if (res.data == true) {
							this.isAlertVisible = true;
							this.resendCodeSeconds = false;
							this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.UPDATE_EMAIL_REQ;
							this.alertType = HEC_CONSTANTS.ERROR_TYPES.success;
							// this.profileComp.loader = false;
							this.loaderService.setValue(false)
							this.sendCode = true
							this.cdr.detectChanges();
							this.InitTimer();
							this.getTimer();

						}
					} else if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.ALREADY_EXIST) {
						this.isAlertVisible = true;
						this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.ALREADY_EXISTS_EMAIL;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						// this.profileComp.loader = false;
						this.loaderService.setValue(false)
						this.cdr.detectChanges();
					}
					else {
						this.isAlertVisible = true;
						this.alertMsgValue = res.statusDescription;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						// this.profileComp.loader = false;
						this.loaderService.setValue(false)
						this.cdr.detectChanges();
					}
				},
				(err) => {
					this.isAlertVisible = true;
					this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.SOMETHING_ERROR;
					this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
					// this.profileComp.loader = false;
					this.loaderService.setValue(false)
					this.cdr.detectChanges();
				}
			)
		}
	}

	public updateEmailAddress() {
		this.isAlertVisible = false;
		this.markFormsTouched(this.updateEmailForm)
		if (this.validate(this.updateEmailForm.form.controls.emailCode)) {
			// this.profileComp.loader = true;
			this.loaderService.setValue(true)
			let payload = {
				data: {
					contactValue: this.updateEmailForm.value.email,
					code: Number(this.updateEmailForm.value.emailCode),
					verificationTypeId: "703103",
				}
			}
			this.sharedServices.updatePrimaryEmail(payload).subscribe(
				async (res:HecResponse) => {
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						await this.profileComp.getUserPersonalDetails();
						this.sendCode = false
						this.isAlertVisible = true;
						this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.EMAIl_UPDATE_SUCCESS;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.success;
						// this.profileComp.loader = false;
						this.loaderService.setValue(false)
						this.timer = new Date();
						this.profileComp.getUserContactDetails();
						if (this.elementView != undefined) {
							this.elementView.nativeElement.innerText = 0;
						}					
						this.updateEmailForm.reset();
						this.resendCodeSeconds = true;
						this.cdr.detectChanges();
						setTimeout(()=>{
							this.isAlertVisible = false;
							this.cdr.detectChanges()
								},2000)
					} else if (res.statusCode == 300) {
						this.alertMsgValue =HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.AUTHENTICATION_CODE_INVALID;
						this.alertType = 'error';
						this.isAlertVisible = true;
						// this.profileComp.loader = false;
						this.loaderService.setValue(false)
						this.cdr.detectChanges();
						this.cdr.markForCheck();
					}else{
						this.isAlertVisible = true;
						this.alertMsgValue = res.statusDescription;
						// this.profileComp.loader = false;
						this.loaderService.setValue(false)
						this.cdr.detectChanges();

					}
				})
		}
	}
  
  public markFormsTouched(form): void {
    CommonHelper.markFormGroupTouched(form);
  }

  public validate(f): boolean {
    if (f.status === 'VALID') {
      return true;
    }
	}
	
	public cancelChange(): void {
		this.isAlertVisible = false;
		this.timer = new Date();
		if (this.elementView != undefined) {
			this.elementView.nativeElement.innerText = 0;
			this.resendCodeSeconds = true;
			this.cdr.detectChanges();

		}
		this.sendCode = false;
		this.cdr.detectChanges();
	}

  public getTimer() {
		if (this.resendCodeSeconds == false) {
			setInterval(() => {
				if (this.resendCodeSeconds == false) {
					if (Number(this.elementView.nativeElement.innerText) > 0) {
						if (Number(this.elementView.nativeElement.innerText) == 1) {
							this.resendCodeSeconds = true;
							this.cdr.detectChanges();
						}
					}
				}
			}, 1000)
		}
		setTimeout(() => {
			this.InitTimer();
		}, 500)
	}


	public InitTimer() {
		this.timer = new Date();
		this.timer.setMinutes(this.timer.getMinutes() + 1);
		function getTimeRemaining(endtime) {
			endtime = new Date(endtime);
			let t = 0;
			let seconds = 0;
			if (endtime > new Date()) {
				t = endtime.getTime() - new Date().getTime();
				seconds = Math.floor((t / 1000) % 60);
			}
			return {
				'total': t,
				'seconds': seconds,
			};
		}

		function initializeClock(id, endtime) {
			const clock = document.getElementById(id);
			const secondsSpan = clock.querySelector('.seconds');

			function updateClock() {
				const t = getTimeRemaining(endtime);
				secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
				if (t.total <= 0) {
					clearInterval(timeinterval);
				}
			}

			updateClock();
			const timeinterval = setInterval(updateClock, 1000);
		}

		initializeClock('clockdiv', this.timer);
	}

}
